import { Box, BoxProps } from "@chakra-ui/react";

function FaqsIcon({
  color = "#0D0D0D",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props}>
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5 2.25C6.39137 2.25 2.25 6.39137 2.25 11.5C2.25 16.6086 6.39137 20.75 11.5 20.75C16.6086 20.75 20.75 16.6086 20.75 11.5C20.75 6.39137 16.6086 2.25 11.5 2.25ZM0.75 11.5C0.75 5.56294 5.56294 0.75 11.5 0.75C17.4371 0.75 22.25 5.56294 22.25 11.5C22.25 17.4371 17.4371 22.25 11.5 22.25C5.56294 22.25 0.75 17.4371 0.75 11.5Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5 7.25C10.8096 7.25 10.25 7.80964 10.25 8.5C10.25 8.91421 9.91421 9.25 9.5 9.25C9.08579 9.25 8.75 8.91421 8.75 8.5C8.75 6.98122 9.98122 5.75 11.5 5.75C13.0188 5.75 14.25 6.98122 14.25 8.5C14.25 9.04634 14.0899 9.55757 13.8138 9.98663C13.6409 10.2554 13.4387 10.5119 13.2523 10.7436C13.2182 10.786 13.1847 10.8275 13.1517 10.8683C12.9971 11.0597 12.8551 11.2354 12.7239 11.4158C12.4003 11.8605 12.25 12.1947 12.25 12.5V13C12.25 13.4142 11.9142 13.75 11.5 13.75C11.0858 13.75 10.75 13.4142 10.75 13V12.5C10.75 11.7007 11.1424 11.0398 11.511 10.5333C11.6667 10.3192 11.8373 10.1081 11.9925 9.91619C12.0236 9.87774 12.054 9.84007 12.0836 9.80329C12.2688 9.57313 12.4265 9.37065 12.5524 9.17495C12.6774 8.98068 12.75 8.74996 12.75 8.5C12.75 7.80964 12.1904 7.25 11.5 7.25Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.4919 16.5C10.4919 15.9477 10.9397 15.5 11.4919 15.5H11.5009C12.0532 15.5 12.5009 15.9477 12.5009 16.5C12.5009 17.0523 12.0532 17.5 11.5009 17.5H11.4919C10.9397 17.5 10.4919 17.0523 10.4919 16.5Z"
          fill={color}
        />
      </svg>
    </Box>
  );
}

export { FaqsIcon };
